import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=62ce461c"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=62ce461c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports